import { useState, useEffect } from 'react'
import { X, Cookie } from 'lucide-react'
import { Link } from 'react-router-dom'

export default function CookieBanner() {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const cookieConsent = localStorage.getItem('cookieConsent')
    if (!cookieConsent) {
      setTimeout(() => setIsVisible(true), 1000)
    }
  }, [])

  const acceptAll = () => {
    localStorage.setItem('cookieConsent', JSON.stringify({
      necessary: true,
      functional: true,
      analytics: true,
      advertising: true,
      acceptedAt: new Date().toISOString()
    }))
    setIsVisible(false)
  }

  const acceptNecessary = () => {
    localStorage.setItem('cookieConsent', JSON.stringify({
      necessary: true,
      functional: false,
      analytics: false,
      advertising: false,
      acceptedAt: new Date().toISOString()
    }))
    setIsVisible(false)
  }

  if (!isVisible) return null

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-white border-t-2 border-gray-200 shadow-2xl animate-slide-up">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-start md:items-center gap-4 justify-between">
          <div className="flex items-start gap-4 flex-1">
            <div className="w-12 h-12 bg-education/10 rounded-xl flex items-center justify-center flex-shrink-0">
              <Cookie className="w-6 h-6 text-education" />
            </div>
            <div className="flex-1">
              <h3 className="text-lg font-bold text-gray-900 mb-2">Usamos cookies</h3>
              <p className="text-sm text-gray-600 mb-2">
                Utilizamos cookies para mejorar tu experiencia, analizar el trafico del sitio y personalizar el contenido. 
                Puedes gestionar tus preferencias en cualquier momento.
              </p>
              <Link to="/cookies" className="text-sm text-education font-semibold hover:underline">
                Mas informacion sobre cookies
              </Link>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto">
            <button
              onClick={acceptNecessary}
              className="px-6 py-3 bg-gray-100 text-gray-700 rounded-lg font-semibold hover:bg-gray-200 transition-colors whitespace-nowrap"
            >
              Solo necesarias
            </button>
            <button
              onClick={acceptAll}
              className="px-6 py-3 bg-education text-white rounded-lg font-semibold hover:bg-education/90 transition-colors whitespace-nowrap"
            >
              Aceptar todas
            </button>
          </div>
        </div>

        <button
          onClick={() => setIsVisible(false)}
          className="absolute top-4 right-4 p-2 text-gray-400 hover:text-gray-600 transition-colors"
          aria-label="Cerrar"
        >
          <X className="w-5 h-5" />
        </button>
      </div>
    </div>
  )
}
